import React from 'react';
import { withRouter, Route } from 'react-router-dom';
import { observer } from 'mobx-react';
import store from 'root/admin/store';

import Edit from './Edit';
import List from './List';

@withRouter
@observer
export default class BillField extends React.Component {
	async componentDidMount() {
		store.ui.setPage(this.props.tabName);
		console.log('getting log');
		// store.model.Tag.log();
	}

	render() {
		const path = this.props.match.path;
		const { model, tabName, rootPath } = this.props;
		const modelName = store.model[model].INFO.description;

		return (
			<>
				<Route
					exact
					path={`${path}/`}
					component={() => <List model={model} rootPath={rootPath} tabName={tabName} modelName={modelName} />}
				/>
				<Route
					exact
					path={`${path}/:id`}
					component={() => <Edit model={model} rootPath={rootPath} tabName={tabName} modelName={modelName} />}
				/>
			</>
		);
	}
}
